import { useLandscapeDisplayInfo } from "@hg/layouts"
import cls from "classnames"
import { round } from "lodash-es"
import { useEffect, useMemo, useState } from "react"

import { getFontSize, handleResize } from "@/utils/adaptFont"
import BackgroundMap from "../BackgroundMap"

import styles from "./index.module.scss"

interface SvgBorderProps {
    width: number
    height: number
}

const SvgBorder: React.FC<SvgBorderProps> = (props) => {
    const { width, height } = props

    const [fontSize, setFontSize] = useState(getFontSize())

    useEffect(() => {
        const id = window.setInterval(() => setFontSize(getFontSize()), 100)
        return () => window.clearInterval(id)
    }, [])

    const size = useMemo(() => {
        const padding = round((2 / 16) * fontSize, 2)
        const w = round(width - (19 / 16) * fontSize * 2, 2)
        const h = round(height - (25 / 16) * fontSize, 2)
        const r = round((48 / 16) * fontSize, 2)
        const d = [
            `M ${padding} ${h}`,
            `L ${padding} ${r}`,
            `A ${r} ${r} 0 0 0 ${r} ${padding}`,
            `L ${w - r} ${padding}`,
            `A ${r} ${r} 0 0 0 ${w - padding} ${r}`,
            `L ${w - padding} ${h} Z`,
        ].join(" ")
        return { w, h, d }
    }, [width, height, fontSize])

    if (width <= 0 || height <= 0) return null

    return (
        <svg viewBox={`0 0 ${size.w} ${size.h}`}>
            <path d={size.d} />
        </svg>
    )
}

const Resize: React.FC<{
    children: React.ReactNode
}> = ({ children }) => {
    const [show, setShow] = useState(false)
    const { width, height } = useLandscapeDisplayInfo()

    useEffect(() => {
        handleResize(width, height, 16)
        setShow(true)
    }, [height, width])

    return (
        <div className={cls(styles.layout, show && styles.show)}>
            <div className={styles.decorations}>
                <div className={styles.contourLines} />
                <div className={styles.terra} />
                <BackgroundMap width={width} height={height} />
                <div className={styles.frame}>
                    <div className={styles.arrow} />
                    <div className={styles.arrow} />
                </div>
                <SvgBorder width={width} height={height} />
                <div className={styles.dots} />
                <div className={styles.blocks} />
                <div className={styles.trees}>
                    <div className={styles.tree1} />
                    <div className={styles.tree2} />
                    <div className={styles.tree3} />
                    <div className={styles.tree4} />
                </div>
                <div className={styles.bottomTex} />
                <div className={styles.bottom} />
            </div>
            {children}
        </div>
    )
}

export default Resize
